import { useQueryClient } from '@tanstack/react-query';
import { useWisecureMutation } from '@wisecure/api-client/hooks';
import type {
  AdminSecurityRequestDetailResponse,
  UpdateSecurityRequestDto,
} from '@wisecure/api-client';
import { queryKeys } from '@/api/query-keys';

export interface SecurityRequestUpdateVariables {
  id: string;
  body: UpdateSecurityRequestDto;
}

/** PATCH a security request, then refresh the lists, the menu badge counts and the detail cache. */
export function useSecurityRequestUpdate() {
  const queryClient = useQueryClient();
  return useWisecureMutation<AdminSecurityRequestDetailResponse, SecurityRequestUpdateVariables>(
    (client, { id, body }) =>
      client.dashboardSecurity.securityDashboardControllerUpdate({ id, requestBody: body }),
    {
      onSuccess: (data) => {
        queryClient.setQueryData(queryKeys.securityRequestDetail(data.id), data);
        queryClient.invalidateQueries({ queryKey: queryKeys.securityRequestsAll });
        queryClient.invalidateQueries({ queryKey: queryKeys.securityRequestCounts });
      },
    },
  );
}
